import { thresholdOsasHsdqQuesionnaire } from '@common/constants';

export function getHsdqResultMessage(score: number) {
    return score > thresholdOsasHsdqQuesionnaire ? 'Wel aanwijzing slaapstoornis' : 'Niet aanwijzing slaapstoornis';
}
